module.exports = __webpack_public_path__ + "static/media/HBE-BE-logo-2.296a2571.png";